module.exports = __webpack_public_path__ + "img/profile-paul.c9bc0e68.webp";